import { render, staticRenderFns } from "./MapaDesburocratizacao.vue?vue&type=template&id=86c1ab86&"
import script from "./MapaDesburocratizacao.vue?vue&type=script&lang=js&"
export * from "./MapaDesburocratizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports